import { render, staticRenderFns } from "./OrderListDataTable.vue?vue&type=template&id=2180ed88&scoped=true&"
import script from "./OrderListDataTable.vue?vue&type=script&lang=js&"
export * from "./OrderListDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180ed88",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VRow,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2180ed88')) {
      api.createRecord('2180ed88', component.options)
    } else {
      api.reload('2180ed88', component.options)
    }
    module.hot.accept("./OrderListDataTable.vue?vue&type=template&id=2180ed88&scoped=true&", function () {
      api.rerender('2180ed88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/OrderListDataTable.vue"
export default component.exports